<template>
  <HeaderTitle single back-target="settings">
    <template #bottom>{{ t("profile.about.contact.item.title") }}</template>
  </HeaderTitle>
  <BasicWrapper white>
    <div class="flex justify-center flex-col w-full items-center">
      <div class="">
        <div
          v-for="contact in contacts"
          :key="contact.title"
          class="grid grid-cols-2 text-left gap-8 mb-3 border-b-[1px] border-gray-90"
        >
          <p class="textBody1">{{ $t(contact.title) }}:</p>
          <p v-if="contact.url" class="textBody1">
            <a
              href="#"
              class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100"
              @click="clickExternalLink(contact.url)"
              >{{ contact.url }}</a
            >
          </p>
          <p v-else-if="contact.mail" class="textBody1">{{ contact.mail }}</p>
          <p v-else class="textBody1">
            {{ $t("contact.default.support.mail") }}
          </p>
        </div>
      </div>
    </div>
    <ExternalLinkModal ref="externalModal" />
  </BasicWrapper>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";
import HeaderTitle from "../../components/v2/layout/header/HeaderTitle.vue";
import { useClientStore } from "../../store/v2/client";
import ExternalLinkModal from "../../components/v2/layout/ExternalLinkModal.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const clientStore = useClientStore();

const contacts = ref<
  Array<{
    title: string;
    mail?: string;
    url?: string;
  }>
>([]);

const externalModal = ref();

function clickExternalLink(url: string) {
  externalModal.value?.openModal(url);
}

onMounted(() => {
  contacts.value = [
    {
      title: "contact.technicalSupport",
      mail: clientStore.getEmailTechnicalSupport,
      url: clientStore.getUrlTechnicalSupport,
    },
    {
      title: "contact.professionalSupport",
      mail: clientStore.getEmailSupport,
      url: clientStore.getUrlSupport,
    },
    {
      title: "contact.appAnswer",
      mail: clientStore.getEmailQuestionsApp,
      url: clientStore.getUrlQuestionsApp,
    },
    {
      title: "contact.membership",
      mail: clientStore.getEmailQuestionsMembership,
      url: clientStore.getUrlQuestionsMembership,
    },
    {
      title: "contact.offerAnswer",
      mail: clientStore.getEmailQuestionsOffer,
      url: clientStore.getUrlQuestionsOffer,
    },
    {
      title: "contact.generalAnswer",
      mail: clientStore.getEmailQuestionsBKK,
      url: clientStore.getUrlQuestionsBKK,
    },
    {
      title: "contact.bgmOfferAnswer",
      mail: clientStore.getEmailQuestionsBGM,
      url: clientStore.getUrlQuestionsBGM,
    },
    {
      title: "contact.bgfAnswer",
      mail: clientStore.getEmailQuestionsBGF,
      url: clientStore.getUrlQuestionsBGF,
    },
    {
      title: "contact.other",
      mail: clientStore.emailMiscellaneous,
      url: clientStore.getUrlMiscellaneous,
    },
  ];
});
</script>
